import {authorizedRequest} from '../../common/request';
import {uploadControllerActionTypes} from './uploadController-action-types';


export const requestUpload = (dispatch, file, uploadAlbumId) => {
	const uploadRequestUri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/uploadrequest`;
	const requestMetadata = {
		title: encodeURI(file.name),
		fileName: encodeURI(file.name),
		fileSize: file.size,
		ccId: uploadAlbumId
	};

	authorizedRequest(uploadRequestUri, requestMetadata, 'POST', false, false)
		.then(postData => {
			const uri = postData.uploadUrl;
			const uuid = postData.uuid;

			dispatch(requestUploadUrlSuccess(dispatch, uri, uuid));
			uploadFile(dispatch, file, uri)
				.then((uploadedFile, request) => {
					uploadedFile.success = true;
					uploadedFile.inProgress = false;
					dispatch(uploadFileSuccess(uploadedFile));
					request = null;
				})
				.catch((error, request) => {
					file.failure = true;
					file.success = false;
					file.inProgress = false;
					dispatch(uploadFileFailure(file, error));
					request = null;
				});

			return {
				type: uploadControllerActionTypes.UPLOAD_CONTROLLER_FILE_STARTED,
				file: file
			};

			
		})
		.catch(error => dispatch(requestUploadUrlFailure(error)));

	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_FILE_REQUEST,
		name: file.name,
		file: file
	};
};


export const albumListRequested = (dispatch, offset, deep = false, max = 10, forSelection = true) => {

	authorizedRequest(
		`${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs?offset=${offset}&max=${max}${
			deep ? '&format=deep' : forSelection ? '&sort=displayOrder&order=asc&format=fast' : ''
		}`
	)
		.then(
			albumList => recievedAlbumList(dispatch, albumList)
		)
		.catch(error => {
			console.log("Error processing album list: " + error)
			dispatch(albumListRequestFailed(error))
		});

	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_ALBUM_SELECT_LIST_FETCHING
	};

};

const albumListRequestFailed = error => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_ALBUM_SELECT_LIST_FETCH_FAILED,
		error: error
	};
};

export const clearUploadItems = () => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_CLEAR_ITEMS
	};
};

export const currentUploadsComplete = albumId => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_CURRENT_COMPLETE,
		albumId: albumId
	};
};

export const setCurrentUploadAlbum = (albumId, albumName) => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_SET_CURRENT_ALBUM,
		albumId: albumId,
		albumName: albumName
	};
};

export const removeFileFromQueue = file => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_DEQUEUE_ITEM,
		file: file
	};
};

export const addFileToUpload = file => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_ADD_FILE,
		file: file
	};
};

export const addFilesToUpload = (files, uploadAlbumId) => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_ADD_FILES,
		files,
		uploadAlbumId
	};
};

export const gotAFile = file => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_ADD_FILE_SUCCESS,
		file: file
	};
};

export const allFilesComplete = () => {
return {
	type: uploadControllerActionTypes.UPLOAD_CONTROLLER_ALL_FILES_UPLOADED
};
};

export const allFilesCompleteClear = () => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_ALL_FILES_UPLOADED_CLEAR
	};
	};
export const clearUploads = () => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_CLEAR_UPLOADS
	};
};

export const clearUploadsList= () => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_CLEAR_UPLOADS_LIST
	};
};

const requestUploadUrlFailure = error => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_POST_URL_FAILURE,
		error: error
	};
};

const requestUploadUrlSuccess = (dispatch, uri, uuid) => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_POST_URL_SUCCESS,
		uri: uri,
		uuid: uuid
	};
};

const uploadFileSuccess = file => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_FILE_SUCCESS,
		file: file,
		name: file.name
	};
};

const uploadFileFailure = (file, error) => {
	file.failure = true;
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_FILE_FAILURE,
		file: file,
		name: file.name,
		error: error
	};
};

const uploadFileProgress = (file, total, loaded) => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_FILE_PROGRESS,
		file: file,
		name: file.name,
		total: total ? total : file.size,
		loaded: loaded,
		progress: loaded / total * 100
	};
};

const uploadFileComplete = completeFile => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_FILE_COMPLETE,
		file: completeFile
	};
};

const uploadFileStarted = (file, total) => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_FILE_STARTED,
		file: file,
		name: file.name,
		total: total,
		progress: 0
	};
};

const recievedAlbumList = (dispatch, listReturn) => {
	const count = listReturn.count;
	const max = listReturn.max;
	const newOffset = listReturn.offset + listReturn.results.length;
	if (newOffset < count) {
		albumListRequested(dispatch, newOffset, false, 100, true);
	}
	dispatch(loadAlbumSelectList(listReturn.results, listReturn.offset));
};

export const loadAlbumSelectList = (albums, offset = 0) => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_ALBUM_SELECT_LIST,
		albums,
		offset,
	};
};

var cancelUpload = false;

export const setCancelUpload = (status = false) =>{
this.cancelUpload= status;
return {
	type: uploadControllerActionTypes.UPLOAD_CONTROLLER_UPLOAD_STOPPED,
	
};
};

const uploadFile = async (dispatch, file, location) => {
	return new Promise((resolve, reject) => {
		let request = new XMLHttpRequest();
		file.request = request;

		let fr = new FileReader();
		fr.onload = () => {
			request.send(file);
		};
		fr.readAsArrayBuffer(file);
		request.open('PUT', location, true);

		request.setRequestHeader('Content-Type', file.type);
		request.setRequestHeader('Content-Disposition', `attachment; filename="${encodeURI(file.name)}"`);
		request.setRequestHeader('X-File-Size', file.size);
		request.setRequestHeader('X-File-Name', encodeURI(file.name));
		request.setRequestHeader('X-File-Type', file.type);

		request.onabort = () => {

		};

		request.onerror = error => {
			reject(file, error);
		};

		request.onloadstart = progressEvent => {
			dispatch(uploadFileStarted(file, progressEvent.total));
		};
		request.upload.onprogress = progressEvent => {
			if(this.cancelUpload){
				request.abort();
			}
			if (!file.inProgress) {
				file.inProgress = true;
			}

			request.lastUpdate = Date.now();
			dispatch(uploadFileProgress(file, progressEvent.total, progressEvent.loaded));
			const myTotal = progressEvent.total;
			const myLoaded = progressEvent.loaded;
            const percentComplete = myLoaded / myTotal * 100;
			if(percentComplete >= 100){
				dispatch(uploadFileComplete(file, progressEvent.total, progressEvent.loaded));
				//window.URL.revokeObjectURL(file.preview);
			}
		};

		request.onreadystatechange = () => {
			if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
				resolve(file, request);
			} else if (request.readyState === XMLHttpRequest.DONE && request.status !== 200) {
				reject(request.statusText, request);
			} else {
				// console.log('ready state', request.readyState);
			}
		};
	});
};

export const pauseUpload = () => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_PAUSE
	};
};

export const continueUpload = () => {
	return {
		type: uploadControllerActionTypes.UPLOAD_CONTROLLER_CONTINUE
	};
};



// WEBPACK FOOTER //
// ./src/uploadController/actions/uploadController-actions.js